import { fetchGetters } from '@/store/extensions/fetch';

export default {
  ...fetchGetters,
};



// WEBPACK FOOTER //
// ./src/store/modules/log/getters.js